import styled from "@emotion/styled";
import { EConsentMarkerProps } from "./EConsentMarker";

export function StampApiMarker(props: EConsentMarkerProps): JSX.Element {
  return <StyledStampApiMarker {...props}>{props.children}</StyledStampApiMarker>;
}

const StyledStampApiMarker = styled("div")<EConsentMarkerProps>((props) => ({
  userSelect: "none",
  boxSizing: "border-box",
  position: "absolute",
  top: props.top,
  left: props.left,
  transform: "translateY(-50%)",
  borderRadius: "2px",
  border: "2px solid #9CE5FF",
  padding: "4px",

  outline: "none",

  backgroundColor: props.isModeSigner ? "rgba(194, 239, 255, 0.6)" : "rgba(194, 239, 255)",

  color: "#878d96",
  fontSize: "10px",
  fontWeight: 500,
  lineHeight: "135%",
  whiteSpace: "nowrap",
  textIndent: "0",

  cursor: "pointer",

  "&:hover": {
    backgroundColor: "rgba(194, 239, 255, 1)",
    //NOTE: marker hover 시, UnlinkButton이 보임
    "& > span": {
      opacity: 1,
    },
  },
}));
